/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable import/no-cycle */
/* eslint-disable react/no-unescaped-entities */
import React, { FC, useEffect, useContext, useState } from 'react';
import { Formik, FormikProps } from 'formik';
import * as Yup from 'yup';
import { IContentfulInformativeModal } from '../../blades/informativeModal/@types';
import Button from '../Button';
import { SKILLBUILDER_ERRORS } from '../../Constants/ErrorMessages';
import TextField from '../FormFields/TextField';
import Typo from '../Typo';
import { getFieldError } from '../FormFields/Utils';
import styles from './skillbuilderSubmissionForm.module.sass';
import useSkillBuilderActions from '../SkillBuilderDetail/useSkillBuilderAction';
import ContentModalContext from '../../AppContext/ContentModalProvider';
import ModalWrapper from '../ModalWrapper';
import InformativeModal from '../../blades/informativeModal/informativeModal';
import contentfulClient from '../../models/Contentful';
import { ContentfulEntry } from '../../blades/widgetTypes';
import { logger } from '../../utils';

export interface SkillBuilderSubmissionFormData {
  submission: string;
  score: number;
}

interface SkillBuilderFormProps {
  entryId: string;
  slug: string;
  earnPoints: number;
  setHasParticipated: React.Dispatch<React.SetStateAction<boolean>>;
  onSubmit: () => void;
}

const ValidationSchema = Yup.object().shape({
  submission: Yup.string().required(SKILLBUILDER_ERRORS.SKILLBUILDER_SUBMISSION_REQUIRED),
});

const SkillbuilderSubmissionForm: FC<SkillBuilderFormProps> = props => {
  const { entryId, slug, earnPoints, setHasParticipated, onSubmit } = props;
  const { handleCreateSkillbuilderSubmission } = useSkillBuilderActions(entryId ?? slug ?? '');
  const { showModal, hideModal } = useContext(ContentModalContext);
  const [modal, setModal] = useState<any>([]);
  const getModalData = async () => {
    try {
      const response = await contentfulClient.getEntries<
        ContentfulEntry<IContentfulInformativeModal>
      >({
        content_type: 'informativeModal',
        'fields.type': 'Skillbuilder Submission PopUp',
        include: 10,
      });
      const modalResponse = response.items.find(
        item => item?.fields?.friendlyName === 'Skillbuilder Submission Pop Up',
      );
      if (modalResponse) {
        setModal(modalResponse);
      }
      return null;
    } catch (error) {
      logger.error(error);
      return null;
    }
  };
  useEffect(() => {
    getModalData();
  }, []);
  return (
    <Formik<SkillBuilderSubmissionFormData>
      onSubmit={(val, helpers) => {
        handleCreateSkillbuilderSubmission
          .run({
            values: { ...val, score: earnPoints },
            formikHelpers: helpers,
          })
          .then(() => {
            onSubmit();
            if (!modal.fields.disabled) {
              showModal(
                <ModalWrapper isActive onClose={hideModal} hasCloseButton>
                  <InformativeModal {...modal} />
                </ModalWrapper>,
              );
            }
            return setHasParticipated(true);
          });
      }}
      initialValues={{} as SkillBuilderSubmissionFormData}
      validationSchema={ValidationSchema}
      enableReinitialize
    >
      {(formikProps: FormikProps<SkillBuilderSubmissionFormData>) => {
        const errors = {
          submission: getFieldError('submission', formikProps),
        };
        return (
          <form onSubmit={formikProps.handleSubmit} id="skillbuilder_form">
            <div className={`is-bgcolor-Grey py-6 px-3 has-text-centered ${styles.textEditor}`}>
              <div>
                <Typo h3 classes="mb-4">
                  Submit your work
                </Typo>
              </div>
              <div className="mb-3 is-bgcolor-White">
                <TextField
                  valueKey="submission"
                  rootClassName="is-bgcolor-Grey"
                  otherFieldProps={{
                    placeholder: 'Type your feedback here',
                    onChange: formikProps.handleChange,
                  }}
                  rows={10}
                  error={errors.submission}
                />
              </div>
              <div className="is-flex is-flex-direction-column mb-4">
                <Typo small>Note:</Typo>
                <Typo small>You may only make one submission to a Skillbuilder</Typo>
              </div>
              <Button
                theme="Filled - Lime"
                type="submit"
                classes={` ${
                  handleCreateSkillbuilderSubmission.status === 'PROCESSING' && 'is-loading'
                }`}
              >
                Submit
              </Button>
            </div>
          </form>
        );
      }}
    </Formik>
  );
};

// const SocialMediaModal = (props: { open: any; onClose: any }) => {
//   const { open, onClose} = props;
//   const { appUser } = useContext(AuthContext);
//   return (
//     <ModalWrapper isActive={open} onClose={onClose} hasCloseButton>
//       <div className={styles.modalRoot}>
//         <Typo classes="mb-5" h2>
//           You did well, {appUser?.first_name}! Share this image and tag @knopro_org to win $50!
//         </Typo>
//
//       </div>
//     </ModalWrapper>
//   );
// };

export default SkillbuilderSubmissionForm;
